// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"100":"170c9343","127":"a88ecc15","315":"a1159620","894":"a9773626"}[chunkId] + ".js";
};